import { render } from "./TreatList.vue?vue&type=template&id=ba729154"
import script from "./TreatList.vue?vue&type=script&lang=js"
export * from "./TreatList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__